import PT from 'prop-types';
import styles from './panel.module.less';
import Panel from './Panel';

const CheckedPanel = ({ children, className = '', ...rest }) => {
    return (
        <Panel className={`${className} ${styles.panelChecked}`} {...rest}>
            {children}
            <div className={`fa-solid fa-2x fa-check ${styles.checkmark}`} aria-hidden />
        </Panel>
    );
};

CheckedPanel.defaultProps = {
    className: '',
    active: false,
};

CheckedPanel.propTypes = {
    className: PT.string,
    active: PT.bool,
    children: PT.node.isRequired,
};

export default CheckedPanel;
